<template>
    <div class="no-gutters">
        <float-label :label="this.nombreLabel" clase="">
            <v-select :loading="this.loading" :class="this.clase" placeholder="Seleccione" v-model="selected" :value="selected" :label="this.campoMostrar" :options="options" :reduce="op => op.id" @input="getValue">
                <template v-slot:option="option">
                    <span :class="option.icon"><i class=""></i></span>
                    {{ option[campoMostrar] }}
                </template>
                <template #spinner="{ loading }">
                    <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                        The .vs__spinner class will hide the text for me.
                    </div>
                </template>
            </v-select>
            <slot name="validation"></slot>
        </float-label>
    </div>
</template>
<style>
    .styleInpt{
       height: calc(2.25rem + 2px);
    }
</style>
<script>
import axios from 'axios';
import FloatLabel from "@/components/layouts/FloatLabel";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import $ from 'jquery';
export default {
    name:"Select",
    components:{
        FloatLabel,
        vSelect
    },
    data() {
        return {
            options: [],
            selected : null,
            optionSelect:[],
            loading:true,
        };
    },
    props: {
        url: null,
        nombreLabel:String,
        idSelect:String,
        clase:null,
        campoMostrar: null,
        autocompletar:null,
        valor:null,
    },
    created(){
        
        },
    mounted(){
        this.getData();
        $(".vs__dropdown-toggle").addClass('styleInpt');    
    },
    computed: {      
        
        },
    watch:{
        valor:function(){
            this.selected=this.valor;
            console.log(this.selected)
        },
    },

    methods:{
        getData() {
        axios
            .get(this.url)
            .then(res => {
                let response = res.data;
                let data = response;
                this.options = [];
                data.map(item => {
                    let array={};
                    array.nombre=item[this.campoMostrar];
                    array.id=item.id;
                    this.optionSelect.push(array);
                    this.options.push(item);
                    this.loading=false
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                this.searching = false;
            });
        },
        getValue(){
            console.log(this.selected);
            this.$emit("val", this.selected);
        },
    }
}

</script>